"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function Page() {
  const router = useRouter();

  useEffect(() => {
    router.push("/ai-face-swap-photo-enhancer/durga-maa");
  }, [router]);

  return <div>Redirecting...</div>;
}
